var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _vm.root.isExpanded
      ? _c(
          "ul",
          { staticClass: "file-tree" },
          [
            _c("li", { staticClass: "tree-node tree-line" }),
            _vm._v(" "),
            _vm._l(_vm.ordered(_vm.root.datasets), function (dataset) {
              return _c(
                "li",
                { key: dataset.uuid, staticClass: "tree-node" },
                [
                  _c("dataset-tree", {
                    attrs: {
                      id: dataset.id,
                      name: dataset.name,
                      permission: dataset.permission,
                    },
                    on: { selectCrumbs: _vm.selectCrumbs },
                  }),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.ordered(_vm.root.distributions), function (dist) {
              return _c(
                "li",
                { key: dist.uuid, staticClass: "tree-node distribution" },
                [
                  _c("div", { staticClass: "text" }, [
                    _c("i", { staticClass: "fa fa-file" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.selectCrumbs([])
                          },
                        },
                      },
                      [_vm._v(_vm._s(dist.name))]
                    ),
                  ]),
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.ordered(_vm.root.groups), function (group) {
              return _c(
                "li",
                { key: group.uuid, staticClass: "tree-node" },
                [
                  _c("div", { staticClass: "pretext" }, [
                    group.datasets.length +
                      group.distributions.length +
                      group.groups.length >
                    0
                      ? _c(
                          "span",
                          {
                            staticClass: "collapsible",
                            on: {
                              click: function ($event) {
                                return _vm.expand(group)
                              },
                            },
                          },
                          [
                            group.isExpanded
                              ? _c("i", { staticClass: "far fa-minus-square" })
                              : !group.isExpanded
                              ? _c("i", { staticClass: "far fa-plus-square" })
                              : _vm._e(),
                          ]
                        )
                      : _c("i", { staticClass: "far fa-square" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _c("span", { staticClass: "folder" }, [
                      group.groups.length == 0
                        ? _c("i", {
                            staticClass: "fad fa-folder",
                            attrs: {
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: "This group does not have subgroups",
                            },
                          })
                        : _c("i", {
                            staticClass: "fad fa-folders",
                            attrs: {
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: "This group has subgroups",
                            },
                          }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.clickGroup(group)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(group.name) + " ")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("sub-tree", {
                    attrs: { root: group },
                    on: { selectCrumbs: _vm.selectCrumbs },
                  }),
                ],
                1
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }